if (typeof MsCrmMkt != 'undefined') {
	MsCrmMkt.MsCrmFormLoader.on("afterFormLoad", function(formEvent) {
		// add utm tag values
		let utmSourceElement = document.getElementById("a38dbffd-208b-ec11-93b0-000d3ab9a442");
		if(utmSourceElement) {
			document.getElementById("a38dbffd-208b-ec11-93b0-000d3ab9a442").value = handl_utm.utm_source;
		}

		let utmMediumElement = document.getElementById("9ae6fd3d-218b-ec11-93b0-000d3ab9a442");
		if(utmMediumElement) {
			document.getElementById("9ae6fd3d-218b-ec11-93b0-000d3ab9a442").value = handl_utm.utm_medium;
		}

		let utmCampaignElement = document.getElementById("15d01f30-218b-ec11-93b0-000d3ab9a442");
		if(utmCampaignElement) {
			document.getElementById("15d01f30-218b-ec11-93b0-000d3ab9a442").value = handl_utm.utm_campaign;
		}

		//add google session id
		let sessionIdElement = document.getElementById("a12a2228-e59a-ec11-b400-0022489d2399");
		if(sessionIdElement) {
			if(window.Cookies.get("_gid")) {
				document.getElementById("a12a2228-e59a-ec11-b400-0022489d2399").value = window.Cookies.get("_gid");
			}
		}
		
		// show title and description which were hidden on form submit
		let $formcontainer = $(
			`[data-form-block-id=${formEvent.formPageId}]`
		).parent(".form-container");

		$formcontainer.siblings(".title").show();
		$formcontainer.siblings(".form-intro-text").show();

		$(".dialogProviderLinkButtonStyle").on("click", (e) => {
			let layout = document.querySelector("[data-layout='true']");
			if (layout) layout.setAttribute("data-layout", "false");
			$(".lp-form-button").addClass("button");
		});
		//remove data layout
		// let layout = document.findElementByAttribute("data-layout","true");
		let layout = document.querySelector("[data-layout='true']");
		if (layout) layout.setAttribute("data-layout", "false");

		//organization
		let organization = document.getElementById(
			"b0dc9c84-8bd2-eb11-bacc-000d3ad87f64"
		);
		if (organization) {
			organization.parentNode.classList.add("icon-map");
			if (organization.getAttribute("placeholder") == "") {
				organization.placeholder = "Organization";
			}
			if (organization.getAttribute("required") == "required") {
				organization.parentNode.classList.add("required");
			}
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").attr("autocomplete", "off");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").attr("type", "search");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").blur(onCompanyFieldBlur);
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").focus(onCompanyFieldFocus);
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").keydown(onCompanyFieldKeyDown);
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").on("input", onCompanyFieldInput);
		}
		//first name
		let firstName = document.getElementById(
			"3f746946-34b4-442c-a677-e232cdd2bc40"
		);
		if (firstName) {
			firstName.parentNode.classList.add("icon-user");
			if (firstName.getAttribute("placeholder") == "") {
				firstName.placeholder = "First Name";
			}
			if (firstName.getAttribute("required") == "required") {
				firstName.parentNode.classList.add("required");
			}
		}

		//last name
		let lastName = document.getElementById(
			"e1dfc514-f301-4cb2-855a-4c8fa8331207"
		);
		if (lastName) {
			lastName.parentNode.classList.add("icon-user");
			if (lastName.getAttribute("placeholder") == "") {
				lastName.placeholder = "Last Name";
			}
			if (lastName.getAttribute("required") == "required") {
				lastName.parentNode.classList.add("required");
			}
		}

		//email
		let email = document.getElementById("7f685ebb-7c54-4cff-a1bc-772562d25c38");
		if (email) {
			email.parentNode.classList.add("icon-email");
			if (email.getAttribute("placeholder") == "") {
				email.placeholder = "E-mail";
			}
			if (email.getAttribute("required") == "required") {
				email.parentNode.classList.add("required");
			}
		}

		//mobile
		let mobile = document.getElementById(
			"ac6a065d-364e-40d6-9a19-d9bf1ed4aa3e"
		);
		if (mobile) {
			mobile.parentNode.classList.add("icon-mobile");
			if (mobile.getAttribute("placeholder") == "") {
				mobile.placeholder = "Telephone";
			}
			if (mobile.getAttribute("required") == "required") {
				mobile.parentNode.classList.add("required");
			}
		}

		//job title
		let jobTitle = document.getElementById(
			"7646c7aa-3a6d-4b55-9a82-4d7a255a7eb3"
		);
		if (jobTitle) {
			jobTitle.parentNode.classList.add("icon-user");
			if (jobTitle.getAttribute("placeholder") == "") {
				jobTitle.placeholder = "Job Title";
			}
			if (jobTitle.getAttribute("required") == "required") {
				jobTitle.parentNode.classList.add("required");
			}
		}

		//Preferred contact method
		let contactMethod = document.getElementById(
			"d97c88db-fc12-4d9d-943d-0f7e71b1455b"
		);
		if (contactMethod) {
			contactMethod.parentNode.classList.add("icon-contactMethod");
			if (contactMethod.getAttribute("placeholder") == "") {
				contactMethod.placeholder = "Preferred contact method";
			}
			if (contactMethod.getAttribute("required") == "required") {
				contactMethod.parentNode.classList.add("required");
			}
		}

		//checkboxes

		let checkboxFields = document.querySelectorAll("[type='checkbox']");
		if (checkboxFields) {
			checkboxFields.forEach((element, i) => {
				if(element.classList.contains('lp-form-fieldInput')) {
					let labels = element.parentNode.getElementsByTagName("label");
					if (labels.length) {
						labels[0].classList.add("label-checkbox");
					}

					if (element.checked) {
						labels[0].classList.add("checked");
					}

					element.addEventListener("change", function(e) {
						if (e.target.checked) {
							if (labels.length) {
								labels[0].classList.add("checked");
							}
						} else {
							if (labels.length) {
								labels[0].classList.remove("checked");
							}
						}
					});
				}
			});
		}
		let button = document.getElementsByClassName("lp-form-button");
		if (button) {
			[].map.call(button, (btn) => btn.classList.add("button"));
		}
		/**
		 *
		 * script provided by Filip
		 * */
		let d365maCompanies = [];
		let companySuggestions = $('#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64').next();
		function onCompanyOptionMouseDown(e) {
			$("#company-not-found").css("display", "none");
			$("#company-not-found").css("visibility", "hidden");

			let index = parseInt(e.delegateTarget.id.replace("option-", ""));
			let companyInfo = d365maCompanies[index];
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").val(companyInfo.orgNr);
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").val(companyInfo.businessName);
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").val(`${companyInfo.businessName} (${companyInfo.orgNr})`);
			$("#a6c4d0a0-09d3-ed11-a7c7-6045bd895444").val(companyInfo.countryCode);
		}

		function onCompanyFieldBlur() {
			let companySuggestions = $('#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64').next();
			if (!$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").val()) {
				$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").val("");
			}

			companySuggestions.css("display", "none");
			companySuggestions.css("visibility", "hidden");
			companySuggestions.removeAttr("class");
		}

		function onCompanyFieldFocus() {
			let companySuggestions = $('#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64').next();
			companySuggestions.removeAttr("style");
			companySuggestions.addClass("companies-suggestions");
			companySuggestions.addClass("dropdown-menu");

			$("#company-not-found").css("display", "none");
			$("#company-not-found").css("visibility", "hidden");
		}

		function onCompanyFieldKeyDown() {
			let companySuggestions = $('#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64').next();
			switch (event.which || event.keyCode) {
				case 40: // Down
					companySuggestions.children(".dropdown-option--highlight").first().removeClass("dropdown-option--highlight").next().addClass("dropdown-option--highlight");
					break;

				case 38: // Up
					companySuggestions.children(".dropdown-option--highlight").first().removeClass("dropdown-option--highlight").prev().addClass("dropdown-option--highlight");
					break;

				case 13: // Enter
					var selected = companySuggestions.children(".dropdown-option--highlight").first();
					if (selected.length > 0) {
						onCompanyOptionMouseDown({ delegateTarget: selected[0] });
						$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").blur();
					}
					break;

				case 27: // Esc
					$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").blur();
					break;

				default: return;
			}

			event.preventDefault();
		}

		function onCompanyOptionHover(e) {
			let companySuggestions = $('#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64').next();
			companySuggestions
				.children(".dropdown-option--highlight")
				.first()
				.removeClass("dropdown-option--highlight");
			$(e.delegateTarget).addClass("dropdown-option--highlight");
		}

		function onCompanyFieldInput() {
			let companySuggestions = $('#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64').next();
			$("#company-not-found").removeAttr("style");
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").val("");
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").val("");
			$("#a6c4d0a0-09d3-ed11-a7c7-6045bd895444").val("");
			companySuggestions.children().remove();
			var company = $("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").val();
			if (company === "") return;

			var url =  window.location.origin + `/wp-json/api/v1/business_search?query=${company}`;


			$.ajax({
				type: 'post',
				url: url,
				success: function (data) {
					if ($("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").val() !== company) return;

					d365maCompanies = data;
					if (data) {
						var i = 0;
						var elements = [];
						data.forEach(o => {
							var orgNo = $("<span>").text(`(${o.orgNr})`);
							var divElement = $("<div>").addClass(`option flag-${o.countryCode}`).append(`${o.businessName} `, orgNo);
							var liElement = $("<li>")
								.attr("id", `option-${i}`)
								.addClass("dropdown-option")
								.mousedown(onCompanyOptionMouseDown)
								.hover(onCompanyOptionHover)
								.append(divElement);
							companySuggestions.append(liElement);
							companySuggestions.addClass('companies-suggestions');
							i++;
						});

						companySuggestions.children(".dropdown-option").first().addClass("dropdown-option--highlight");
					}
				}
			});
		}

		function onCompanyNotFoundClicked() {
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").attr("hidden", "hidden");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").parent().attr("hidden", "hidden");
			$("#company-not-found").css("display", "none");
			$("#company-not-found").css("visibility", "hidden");

			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").parent().parent().parent().removeAttr("hidden");
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").parent().parent().parent().removeAttr("hidden");

			$("#clear-company-not-found").removeAttr("style");

			setCompanyFieldAsNotRequired();
			setCompanyNameAndOrgNumberAsRequired();
		}

		function clearCompanyNotFound() {
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").removeAttr("hidden");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").parent().removeAttr("hidden");
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").parent().parent().parent().attr("hidden", "hidden");
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").parent().parent().parent().attr("hidden", "hidden");

			$("#clear-company-not-found").css("display", "none");
			$("#clear-company-not-found").css("visibility", "hidden");

			setCompanyFieldAsRequired();
			setCompanyNameAndOrgNumberAsNotRequired();
		}

		function setCompanyFieldAsNotRequired() {
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").parent().removeAttr("data-required-field");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").removeAttr("required");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").removeAttr("aria-required");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").removeAttr("data-requirederrormessage");
		}

		function setCompanyFieldAsRequired() {
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").parent().attr("data-required-field", "true");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").attr("required", "required");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").attr("aria-required", "true");
			$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").attr("data-requirederrormessage", "Påkrevd");
		}

		function setCompanyNameAndOrgNumberAsRequired() {
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").attr("required", "required");
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").attr("aria-required", "true");
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").attr("data-requirederrormessage", "Påkrevd");

			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").attr("required", "required");
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").attr("aria-required", "true");
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").attr("data-requirederrormessage", "Påkrevd");
		}

		function setCompanyNameAndOrgNumberAsNotRequired() {
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").removeAttr("required");
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").removeAttr("aria-required");
			$("#de7bccb5-8bd2-eb11-bacc-000d3ad87f64").removeAttr("data-requirederrormessage");

			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").removeAttr("required")
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").removeAttr("aria-required");
			$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").removeAttr("data-requirederrormessage");
		}

		
		$("#b0dc9c84-8bd2-eb11-bacc-000d3ad87f64").after(
			`<ul id="companies-suggestions" style="display: none; visibility: hidden;">
				<li id="no-option-found" class="no-options">
					<p>${msdTranslations.instruction_company_name}</p>
				</li>
			</ul>`);
		$("#fb485e05-36d3-eb11-bacc-000d3ad87f64").before(
			`<a href="javascript:onCompanyNotFoundClicked()" id="company-not-found" role="button" tabindex="0" class="text-link small switch-company-fields" style="display: none; visibility: hidden;">
			${msdTranslations.cant_find_your_business}
</a>`
		);
		$("#ac29c7ec-8bd2-eb11-bacc-000d3ad87f64").after(
			`<a href="javascript:clearCompanyNotFound()" id="clear-company-not-found" role="button" tabindex="0" class="text-link small switch-company-fields" style="display: none; visibility: hidden;">
				${msdTranslations.back_to_company_search}
			</a>`
		);
		setCompanyFieldAsRequired();

		$("#clear-company-not-found").on("click", function(e) {
			e.preventDefault();
			clearCompanyNotFound();
		});

		$("#company-not-found").on("click", function(e) {
			e.preventDefault();
			onCompanyNotFoundClicked();
		});

		function onChangeDoNotSendMailsCheckbox() {
			if ($("#bddafd65-310b-4d51-91b4-d251a5002add").is(":checked")) {
				uncheckRelatedCheckboxes();
				disableRelatedCheckboxes();
			} else {
				enableRelatedCheckboxes();
			}
		}

		function uncheckRelatedCheckboxes() {
			$("div.marketing-subscription-list")
				.children("label", "class:checked")
				.removeClass("checked");
		}

		function enableRelatedCheckboxes() {
			$("div.marketing-subscription-list")
				.children("input[type='checkbox']")
				.removeAttr("disabled");
		}

		function disableRelatedCheckboxes() {
			$("div.marketing-subscription-list")
				.children("input[type='checkbox']")
				.attr("disabled", true);
		}
		
		onChangeDoNotSendMailsCheckbox();
		$("#bddafd65-310b-4d51-91b4-d251a5002add").change(
			onChangeDoNotSendMailsCheckbox
		);

		var errorIconDiv = document.createElement("div");
		errorIconDiv.innerHTML = `<svg width="60px" height="60px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<title>Group 2</title>
							<g id="Modules---sprint-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g id="Error-message" transform="translate(-82.000000, -69.000000)" stroke="#FD88A0">
									<g id="Group-2" transform="translate(82.000000, 69.000000)">
										<circle id="Oval" stroke-width="3" cx="30" cy="30" r="28.5"></circle>
										<g id="Group" transform="translate(30.500000, 29.500000) rotate(45.000000) translate(-30.500000, -29.500000) translate(14.000000, 13.000000)" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
											<line x1="0.3" y1="16.5" x2="32.7" y2="16.5" id="Line"></line>
											<line x1="-1.43114687e-17" y1="16.5" x2="33" y2="16.5" id="Line" transform="translate(16.500000, 16.500000) rotate(90.000000) translate(-16.500000, -16.500000) "></line>
										</g>
									</g>
								</g>
							</g>
						</svg>`;
		errorIconDiv.className = "error-icon";
		$(".dialogProviderInternalContainerStyle").append(errorIconDiv);
	});

	MsCrmMkt.MsCrmFormLoader.on("afterFormSubmit", function(event) {
		let $formcontainer = $(`[data-form-block-id=${event.formPageId}]`).parent(
			".form-container"
		);
		
		let formContainerDiv = $(".dynamics-form");
		let MSDformType = formContainerDiv.attr('data-formtype');
		let gtmEventType = 'ccFormSent';
		let formSectionTitle = formContainerDiv.find('.title');

		if(MSDformType == 'event') {
			gtmEventType = 'ccFormSentEvent'
		}

		if(MSDformType == 'Download') {
			gtmEventType = 'ccFormSentDownload'
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			"event": gtmEventType,
			"ccFormTitle": formSectionTitle.text()
		});

		$formcontainer.siblings(".title").hide();
		$formcontainer.siblings(".form-intro-text").hide();

		let message = $(".onFormSubmittedFeedbackMessage").text();
		$(".onFormSubmittedFeedbackMessage").html(
			"<p class='h1'>" + message + "</p>"
		);
		$(".onFormSubmittedFeedbackButton").removeClass(
			"onFormSubmittedFeedbackButtonSuccess"
		);
	});
}